import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { APIURL, STORAGEURL } from "..";
import { Link, useNavigate } from "react-router-dom";
import { AppContext, LinkButton } from "./Layout";
import Karticka from "../components/Karticka";
import parse from 'html-react-parser';

import hp_pic from "../assets/hp_pic.png";
import hp_pattern from "../assets/svg/hp_pattern.svg";
import logo from "../assets/svg/logo.svg"
import sqrhi from "../assets/svg/sqrhi.svg";
import sqrlo from "../assets/svg/sqrlo.svg";
import star from '../assets/svg/star.svg'
import KartySwiper from "../components/KartySwiper";
import Loading from "../components/UI/Loading";

const HP = () => {
  const { language, pages, setPages } = useContext(AppContext)||{};
  const data = pages.hp;
  const navigate = useNavigate();

  const getPageData = async () => {
    await axios
      .post(APIURL + "/page", { name: "hp", language: language })
      .then(async (response) => {
        setPages((prev)=>({ ...prev, hp:response.data.body}));
      })
      .catch(() => {
        navigate("/");
      });
  };

  useEffect(() => {
    if (!pages?.hp) {
      getPageData();
    }
  }, [pages]);

  if (!data) {return <Loading />} else
  return (
    <main className="flex flex-col items-center maxSection overflow-x-hidden">
      <div className="w-full text-center py-14">
        <div className="flex justify-center"><img src={logo} alt="Logo Lorem ipsum" className="max-w-[50vw]" /> </div>
        <h1 className=" m-auto max-w-2xl">{data.intro_title}</h1>
        <p className="text-purplee-400 font-semibold">{data.intro_text}</p>
        <div className="flex mobil:flex-col gap-2 justify-center m-6 items-center">
          <LinkButton type="workshop" className="mobil:!w-full" />
          <LinkButton type="karty" light className="mobil:!w-full" />
        </div>
      </div>
      <div className="w-full maxSection">
        <div className="w-full mobil:pb-14">
          <img src={hp_pattern} className="absolute w-full min-w-[800px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
          <img src={hp_pic} className="m-auto w-4/5 mobil:w-full" />
        </div>
        <div className="absolute w-full h-full mobil:h-auto left-0 bottom-0 pt-[5%] pb-[25%] px-4 mobil:py-0 gap-2 flex justify-between">
          <div className="glassbox self-start mobil:items-start">
            <img src={star} />
            <p>Garance nápadu<br/>zaručena!</p>
          </div>
          <div className="glassbox self-end mobil:items-end">
            <p className="text-right">Zrychlení kreativního<br/>procesu až o</p>
            <b className="text-5xl mobil:text-3xl">67 %</b>
          </div>
        </div>
      </div>
      <div className="hpSection items-end" id='jak-to-funguje'>
        <div>
          <h2>{data.claim_title}</h2>
          <p className="font-semibold">{data.claim_subheader}</p>
        </div>
        <div className="parsedDiv !text-purplee-400">{parse(data.claim_text||'')}</div>
      </div>
      <img
        src={STORAGEURL+data.claim_img}
        className="rounded-xl object-cover mobil:aspect-square"
        alt={data.claim_title}
      />
      <div className="flex mobil:flex-col gap-4 py-7 ">
        {data.claim_iterms?.map((i) => (
          <div key={i.item_name} className="basis-full p-7 rounded-xl bg-purplee-200">
            {i.icon&&<img src={STORAGEURL+i.icon} alt={i.item_name} />}
            <h4>{i.item_name}</h4>
            <p>{i.text}</p>
          </div>
        ))}
      </div>
      <div className="hpSection items-center py-14 gap-y-7">
        <div>
          <h2>{data.workshop_title}</h2>
          <p>{data.workshop_subtitle}</p>
          <span>{data.workshop_text}</span>
          <LinkButton type="workshop" />
        </div>
        <div>
          <img src={STORAGEURL+data.workshop_image} className=" rounded-xl w-full h-auto" />
          <img src={sqrhi} className="absolute w-[30%] -left-4 -top-4" />
          <img src={sqrlo} className="absolute w-[56%] -bottom-4 -right-4" />
        </div>
      </div>
      <div className="hpSection items-center gap-y-7 mobil:flex-col-reverse">
        <KartySwiper />
        <div>
          <h2>{data.cards_title}</h2>
          <p>{data.cards_subtitle}</p>
          <span>{data.cards_text}</span>
          <LinkButton type="karty" />
        </div>
      </div>
    </main>
  );
};

export default HP;
